import { render, staticRenderFns } from "./FlowPublic.vue?vue&type=template&id=761b3aac&scoped=true"
import script from "./FlowPublic.vue?vue&type=script&lang=js"
export * from "./FlowPublic.vue?vue&type=script&lang=js"
import style0 from "./FlowPublic.vue?vue&type=style&index=0&id=761b3aac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761b3aac",
  null
  
)

export default component.exports